import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { TruckType } from '../models/truck-type';



@Injectable({
  providedIn: 'root'
})
export class truckTypeService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getTruckTypes(includeInactive?: boolean): Observable<TruckType[]> {
    let queryParameters = new HttpParams();

    if (includeInactive != null) {
      queryParameters = queryParameters.set('includeInactive', String(includeInactive));
    }

    return this.httpClient.get<TruckType[]>(`${this.basePath}/api/truckType`);
  }

  public getTruckType(truckTypeId: number): Observable<TruckType> {
    return this.httpClient.get<TruckType>(`${this.basePath}/api/truckType/${truckTypeId}`);
  }

  public postTruckTypeDTO(truckTypeDTO: TruckType): Observable<TruckType> {
    return this.httpClient.post<TruckType>(`${this.basePath}/api/truckType`, truckTypeDTO);
  }

  public putTruckTypeDTO(truckTypeDTO: TruckType): Observable<TruckType> {
    return this.httpClient.put<TruckType>(`${this.basePath}/api/truckType/${truckTypeDTO.id}`, truckTypeDTO);
  }

  public deleteTruckTypeDTO(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/truckType/${id}`);
  }

}
